import { render, staticRenderFns } from "./ArticleShow.vue?vue&type=template&id=a094a584&scoped=true"
import script from "./ArticleShow.vue?vue&type=script&lang=js"
export * from "./ArticleShow.vue?vue&type=script&lang=js"
import style0 from "./ArticleShow.vue?vue&type=style&index=0&id=a094a584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a094a584",
  null
  
)

export default component.exports